import React from "react";

export default function NotFound() {
    return (
        <div id="notfound" className="text-center">Такой страницы не существует!</div>
    )
}